module.exports = __webpack_public_path__ + "img/tiaodengzheng.35a0b550.png";